import { Alert, Button, Center, Loader, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconAlertCircle, IconInbox } from '@tabler/icons-react';
import type { ComponentType, ReactNode } from 'react';
import { errorMessage } from '@/api/client';

export function EmptyState({
  icon: Icon = IconInbox,
  title,
  description,
  action,
}: {
  icon?: ComponentType<{ size?: number; stroke?: number }>;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Center py={48} px="md">
      <Stack align="center" gap="xs" maw={420} ta="center">
        <ThemeIcon size={52} radius="xl" variant="light" color="gray">
          <Icon size={26} stroke={1.6} />
        </ThemeIcon>
        <Text fw={600}>{title}</Text>
        {description && (
          <Text c="dimmed" fz="sm">
            {description}
          </Text>
        )}
        {action}
      </Stack>
    </Center>
  );
}

export function LoadingState({ label }: { label?: string }) {
  return (
    <Center py={56}>
      <Stack align="center" gap="xs">
        <Loader size="sm" />
        {label && (
          <Text c="dimmed" fz="sm">
            {label}
          </Text>
        )}
      </Stack>
    </Center>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <Alert color="red" variant="light" icon={<IconAlertCircle size={18} />} title="Could not load this" my="md">
      <Stack gap="xs" align="flex-start">
        <Text fz="sm">{errorMessage(error)}</Text>
        {onRetry && (
          <Button size="xs" variant="light" color="red" onClick={onRetry}>
            Try again
          </Button>
        )}
      </Stack>
    </Alert>
  );
}
